import Qs from "qs";
import axios from './apiClient';
import productsApi from './products';
import machinesApi from './machines';

function getSystemSettings() {
  return axios.get('SystemSettings/GetSystemSettings/');
}
function getVersion() {
  return axios.get('AppVersion');
}
function getExporterSettings() {
  return axios.get('SystemSettings/GetExporterSettings/');
}
function saveOrUpdateExporterSettings(s) {
  return axios.post('SystemSettings/SaveOrUpdateExporterSettings/', s);
}
function getProjects(pagination, filters, projectType) {
  const queryParams = {
    ...pagination,
    projectType,
    ...filters,
  };

  return axios.get(
    'Projects/GetAll',
    {
      params: {
        ...queryParams,
      },
      paramsSerializer: p => Qs.stringify(p, {comma: true, allowDots: true, skipNulls: true}),
    },
  );
}
function downloadProjectsReport(pagination, filters, projectType) {
  const queryParams = {
    ...pagination,
    projectType,
    ...filters,
  };

  return axios.get(
    'Projects/Export',
    {
      params: {
        ...queryParams,
      },
      responseType: 'arraybuffer',
      paramsSerializer: p => Qs.stringify(p, {comma: true, allowDots: true, skipNulls: true}),
    },
  );
}
function isProductNumberInUse(number, contextProductId) {
  return axios.get(
    'Products/IsProductNumberInUse/',
    {
      params: {
        number,
        contextProductId,
      },
    },
  );
}
function isOrderNumberInUse(number, productId, contextOrderId) {
  return axios.get(
    'Products/IsOrderNumberInUse/',
    {
      params: {
        number,
        productId,
        contextOrderId,
      },
    },
  );
}
function isActivityNumberInUse(number, productId, orderId, contextActivityId) {
  return axios.get(
    'Products/IsActivityNumberInUse/',
    {
      params: {
        number,
        productId,
        orderId,
        contextActivityId,
      },
    },
  );
}
function getNextAvailableProductNumber() {
  return axios.get(
    'Products/GetNextAvailableProductNumber/',
  );
}
function getNextAvailableOrderNumber(productId) {
  return axios.get('Products/GetNextAvailableOrderNumber/',
    {
      params: {
        productId,
      },
    },
  );
}
function getNextAvailableActivityNumber(productId, orderId) {
  return axios.get(
    'Products/GetNextAvailableActivityNumber/',
    {
      params: {
        productId,
        orderId,
      },
    },
  );
}
function getProjectsStatistics() {
  return axios.get('Projects/Statistics');
}
function editProjectMachineUsage(projectMachineUsage) {
  return axios.put('Projects/EditProjectMachineUsage/', projectMachineUsage);
}
function deleteTimeRecordingMetadataDefinition(name) {
  return axios.delete(
    `Metadata/DeleteTimeRecordingMetadataDefinition/?metadataDefinitionName=${encodeURIComponent(name)}`
  );
}
function deleteUserMetadataDefinition(name) {
  return axios.delete(
    `Metadata/DeleteUserMetadataDefinition/?metadataDefinitionName=${encodeURIComponent(name)}`
  );
}
function getExporterMetadataDefinitions() {
  return axios.get('Metadata/GetExporterDefinitions');
}
function getTimeRecordingMetadataDefinitions() {
  return axios.get('Metadata/GetTimeRecordingDefinitions');
}
function getUserMetadataDefinitions() {
  return axios.get('Metadata/GetUserMetadataDefinitions');
}
function saveOrUpdateTimeRecordingMetadataDefinition(md) {
  return axios.post('Metadata/SaveOrUpdateTimeRecordingMetadataDefinition/', md);
}
function saveOrUpdateUserMetadataDefinition(md) {
  return axios.post('Metadata/SaveOrUpdateUserMetadataDefinition/', md);
}
function getTimeModels() {
  return axios.get('TimeModels/Get');
}
function createTimeModel(t) {
  return axios.post('TimeModels/Create/', t);
}
function editTimeModel(t) {
  return axios.put('TimeModels/Edit/', t);
}
function deleteTimeModel(id) {
  return axios.delete(`TimeModels/Delete/${id}`);
}
function getUserSettings() {
  return axios.get('UserSettings/GetAll');
}
function bulkSaveOrUpdateUserSettings(userSettings) {
  return axios.post('UserSettings/BulkSaveOrUpdate/',
    {
      userSettings,
    }
  );
}
function saveUserTimeModels(userTimeModels) {
  return axios.post('UserSettings/SaveUserTimeModels/', userTimeModels);
}
function downloadUserTimesExport(reportMonth ) {
  return axios.get('Export/UserTimesV2',
    {
      responseType: 'arraybuffer',
      params: reportMonth
    }
  );
}
function createProject(project) {
  return axios.post('Projects/SaveForUser/', project);
}
function deleteProjectMachineUsage(id) {
  return axios.delete(`Projects/DeleteProjectMachineUsage/${id}`);
}
function downloadTenantMachineUsageReport(start, end) {
  return axios.get('TenantReports/Download/',
    {
      params: {
        start,
        end,
      },
      responseType: 'arraybuffer',
    }
  ).catch(function (error) {
      window.alert(String.fromCharCode.apply(null, new Uint8Array(error.response.data)));
  });
}
function searchAufgabenpark(term) {
  return axios.get(`Projects/SearchAufgabenpark?term=${encodeURIComponent(term)}`);
}
function getExtraCharges() {
  return axios.get('ExtraCharges/GetAll');
}
function getAnyExtraChargeHasMaxStundenLohnart() {
  return axios.get('ExtraCharges/AnyHasMaxStundenLohnart');
}
function createExtraCharge(extraCharge) {
  return axios.post('ExtraCharges/Create/', extraCharge);
}
function editExtraCharge(extraCharge) {
  return axios.put('ExtraCharges/Edit/', extraCharge);
}
function deleteExtraCharge(extraChargeId) {
  return axios.delete(`ExtraCharges/Delete/${extraChargeId}`);
}

export default {
  getVersion,
  productsApi,
  machinesApi,
  getProjects,
  downloadProjectsReport,
  isProductNumberInUse,
  isOrderNumberInUse,
  isActivityNumberInUse,
  getNextAvailableProductNumber,
  getNextAvailableOrderNumber,
  getNextAvailableActivityNumber,
  getProjectsStatistics,
  getSystemSettings,
  getExporterSettings,
  saveOrUpdateExporterSettings,
  editProjectMachineUsage,
  deleteTimeRecordingMetadataDefinition,
  deleteUserMetadataDefinition,
  getExporterMetadataDefinitions,
  getTimeRecordingMetadataDefinitions,
  getUserMetadataDefinitions,
  saveOrUpdateTimeRecordingMetadataDefinition,
  saveOrUpdateUserMetadataDefinition,
  getTimeModels,
  createTimeModel,
  editTimeModel,
  deleteTimeModel,
  getUserSettings,
  bulkSaveOrUpdateUserSettings,
  saveUserTimeModels,
  downloadUserTimesExport,
  createProject,
  deleteProjectMachineUsage,
  downloadTenantMachineUsageReport,
  searchAufgabenpark,
  getExtraCharges,
  getAnyExtraChargeHasMaxStundenLohnart,
  createExtraCharge,
  editExtraCharge,
  deleteExtraCharge,
};
